import * as React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import DriveRow from "../DriveRow";

export const FolderContentList = ({rows}) => {
    return (
        <TableContainer component="Paper" elevation={0}>
            <Table aria-label="drive table" size={"small"}>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align="right">Size</TableCell>
                        <TableCell align="right">Modified</TableCell>
                        <TableCell align="right"/>
                        <TableCell align="right"/>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map(row => {
                            return <DriveRow row={row}/>
                        })
                    }
                </TableBody>
            </Table>

        </TableContainer>

    );
};